/**
 *
 * Material UI styles for MobileSmsPreview
 *
 *
 * @see https://material-ui.com/styles/basics
 *
 */

export const styles = theme => ({
  message: {
    '&:not(:last-of-type)': {
      marginBottom: theme.spacing(1),
    },
  },
});

export const messageBubbleStyles = theme => ({
  messageBubble: {
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    display: 'inline-block',
    maxWidth: 160,
    overflowY: 'scroll',
    padding: theme.spacing(1),
    maxHeight: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  egressBubble: {
    backgroundColor: theme.palette.common.blue400,
    borderBottomLeftRadius: 10,
    color: theme.palette.common.white,
    marginLeft: 'auto',
  },
  ingressBubble: {
    backgroundColor: theme.palette.common.gray200,
    borderBottomRightRadius: 10,
    color: theme.palette.common.black,
    marginRight: 'auto',
  },
  // WhatsApp's brand green, not a Fountain status colour, so it is pinned
  // rather than bound: a Ripple change must not redefine another company's
  // brand. Reading it off the theme would not hold it — `common.green400`
  // resolves through the ramp to `success`. The white preview text sits at
  // 2.31:1 on this green, which is the brand's cost and not a Fountain
  // surface's.
  whatsappGreenBubble: {
    backgroundColor: '#29c278',
    borderBottomLeftRadius: 10,
    color: theme.palette.common.white,
    marginLeft: 'auto',
  },
});

export default styles;
